import React from "react";
import MedicalPageLayout from "../../components/medical/MedicalPageLayout";
import { MEDICAL_PAGES } from "../../data/medicalPagesContent";
import HighlightedContactSection from "../../components/HighlightedContactSection";

export default function AwardsPage() {
  const page = MEDICAL_PAGES.auszeichnungen;
  const awards = page.awards || [];

  return (
    <MedicalPageLayout page={page}>
      {awards.length > 0 && (
        <div className="mt-12 space-y-10">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900 border-b border-neutral-200 pb-2">
            Unsere Auszeichnungen
          </h2>
          {awards.map((award, i) => (
            <article
              key={i}
              className="pl-4 border-l-4 border-amber-500/80 bg-neutral-50/80 rounded-r-lg py-4 pr-6"
            >
              <div className="flex flex-wrap items-baseline gap-2">
                <h3 className="text-lg font-semibold text-neutral-900">
                  {award.name}
                </h3>
                {award.subtitle && (
                  <span className="text-sm text-neutral-600">
                    {award.subtitle}
                  </span>
                )}
              </div>
              {award.years && (
                <p className="mt-1 text-sm font-medium text-amber-800/90">
                  {Array.isArray(award.years) ? award.years.join(", ") : award.years}
                </p>
              )}
              {award.description && (
                <p className="mt-3 text-[15px] leading-7 text-neutral-700">
                  {award.description}
                </p>
              )}
            </article>
          ))}
        </div>
      )}
      <div className="mt-12 w-full max-w-none">
        <HighlightedContactSection
          heading="Mehr über uns erfahren"
          description="Sie haben Fragen zu unseren Auszeichnungen oder möchten mit uns zusammenarbeiten?"
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-auszeichnungen-contact"
        />
      </div>
    </MedicalPageLayout>
  );
}
